<div class="image-cropper-container">
  <div class="image-container">
    <image-cropper [imageFile]="imageFile" [maintainAspectRatio]="false" format="png" output="base64" (imageCropped)="imageCropped($event)" (imageLoaded)="imageLoaded($event)" (cropperReady)="cropperReady()" (loadImageFailed)="loadImageFailed()"></image-cropper>
    @if (showBlackOverlay) {
      <div class="black-overlay"></div>
    }
  </div>
</div>